__turbopack_context__.v({
  "shimmer": "styles-module-scss-module__uxkl6W__shimmer",
  "shimmer-effect": "styles-module-scss-module__uxkl6W__shimmer-effect",
  "shimmer-wrapper": "styles-module-scss-module__uxkl6W__shimmer-wrapper",
});
